import React from 'react'
import PropTypes from 'prop-types'
import ActionComponent from '../../../../components/ActionComponent'
import { connect } from 'react-redux'
import AppStore from 'store/AppStore'
import ApplicationConf from 'conf/ApplicationConf'
import FractionAction from '../actions/FractionAction'
import ReferencialAction from '../../../action/ReferencialAction'
import DtoReferencial from '../../../dto/DtoReferencial'
import DtoReferencialItem from '../../../dto/DtoReferencialItem'
import i18n from 'simple-react-i18n'
import FractionDto from '../dto/FractionDto'
import Checkbox from '../../../../components/forms/Checkbox'
import moment from 'moment'
import 'moment/locale/fr'
import Select from '../../../../components/forms/Select'
import SieauAction from '../../../../components/sieau/SieauAction'
import Input from '../../../../components/forms/Input'
import Textarea from '../../../../components/forms/Textarea'
import { getReferencialComponent } from '../../../util/ReferencialUtils'
import { updateMaterialize } from '../../../../utils/MaterializeUtils'
import ReplaceModal from '../../ReplaceModal'
import { isEqual, omit } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_FRACTION,
    PATH_REFERENCIAL_FRACTION_LINK,
    PATH_REFERENCIAL_FRACTION_NEW,
} from '../../../../home/constants/RouteConstants'
import { push } from '@lagunovsky/redux-react-router'
import ToastrAction from 'toastr/actions/ToastrAction'
import DeleteModal from '../../DeleteModal'
import { sandreFractionLink } from '../../../../conf/SieauConstants'
import { getUser } from '../../../../utils/SettingUtils'
import HomeAction from 'home/actions/HomeAction'
import logoSandre from 'assets/pictures/logo_sandre.png'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { hasValue } from 'utils/NumberUtil'
import { Box, Card, CardContent, Grid2 } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

moment.locale('fr')

class FractionApp extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            fraction: new FractionDto({}),
        }
    }

    setReadMode = () => {
        this.setState({ readMode: true })
    }

    setEditMode = () => {
        this.setState({ readMode: false })
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        AppStore.dispatch(FractionAction.reset())
    }

    componentWillMount() {
        if (this.props.params.code !== 'new') {
            AppStore.dispatch(FractionAction.fetchFraction(this.props.params.code))
            this.setReadMode()
        } else {
            this.setEditMode()
        }
        AppStore.dispatch(ReferencialAction.fetchReferencialStatus())
        AppStore.dispatch(ReferencialAction.fetchReferencialSupport())
        AppStore.dispatch(HomeAction.setHelpLink('', ''))
        this.toNavbarFraction(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.code !== this.props.params.code) {
            AppStore.dispatch(FractionAction.fetchFraction(nextProps.params.code))
        } else if (nextProps.params.code === 'new') {
            AppStore.dispatch(SieauAction.forceFetch('title', [
                {
                    title: i18n.referencials,
                    href: PATH_REFERENCIAL,
                },
                {
                    title: i18n.fractions,
                    href: PATH_REFERENCIAL_FRACTION,
                },
                {
                    title: i18n.new,
                    href: PATH_REFERENCIAL_FRACTION_NEW,
                },
            ]))
        } else {
            if (!isEqual(nextProps.fraction, this.props.fraction)) {
                AppStore.dispatch(SieauAction.forceFetch('title', [
                    {
                        title: i18n.referencials,
                        href: PATH_REFERENCIAL,
                    },
                    {
                        title: i18n.fractions,
                        href: PATH_REFERENCIAL_FRACTION,
                    },
                    {
                        title: this.props.params.code + (nextProps.fraction.name ? ` - ${nextProps.fraction.name}` : ''),
                        href: PATH_REFERENCIAL_FRACTION_LINK + this.props.params.code,
                    },
                ]))
                this.setState({ fraction: nextProps.fraction })
            }
            if (!isEqual(this.props.isEditMode, nextProps.isEditMode) || !isEqual(this.props.fraction.code, nextProps.fraction.code) || !isEqual(this.props.fractions, nextProps.fractions)) {
                this.toNavbarFraction(nextProps)
            }
        }
    }

    onReplace = newCode => {
        AppStore.dispatch(FractionAction.replaceFraction(this.state.fraction.code, newCode.code))
    }

    getRequiredFunction = (actions) => {
        AppStore.dispatch(actions)
        this.setReadMode()
    }

    getFractionLinks = props => {
        return [
            {
                href: sandreFractionLink + props.fraction.code,
                img: logoSandre,
                label: i18n.sandre.toUpperCase(),
            },
        ]
    }

    toNavbarFraction(props = this.props) {
        const { fraction } = this.state
        const state = this.props.referencialStatus.find(status => status.code === parseInt(fraction.state))?.name
        const actions = (() => {
            if (props.params.code === 'new' && (!props.fraction || !props.fraction.code)) {
                return {
                    save: () => {
                        const existCode = this.props.fractions.find(f => f.id === fraction.code)
                        if (existCode) {
                            AppStore.dispatch(ToastrAction.error(i18n.codeAlreadyExists))
                        } else if (!fraction.code) {
                            AppStore.dispatch(ToastrAction.error(i18n.thanksToEnterCode))
                        } else {
                            this.getRequiredFunction(FractionAction.createFraction({
                                ...fraction,
                                state,
                            }), props)
                        }
                    },
                    cancel: () => {
                        AppStore.dispatch(push(PATH_REFERENCIAL_FRACTION))
                        this.setReadMode()
                    },
                }
            }
            if (!this.state.readMode) {
                return {
                    save: () => {
                        this.getRequiredFunction(FractionAction.updateFraction({
                            ...fraction,
                            state,
                        }, fraction.code), props)
                    },
                    cancel: () => {
                        this.setState({ fraction: props.fraction })
                        this.setReadMode()
                    },
                }
            }
            return {
                edit: () => {
                    this.setEditMode()
                },
                deleteCheck: () => {
                    AppStore.dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.fractionCountDelete(this.props.params.code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <DeleteModal
                            onDelete={ () => AppStore.dispatch(FractionAction.deleteFraction(fraction.code)) }
                        />,
                        dismissible: false,
                    }
                    AppStore.dispatch(SieauAction.setPopup(popup))
                },
                replace: () => {
                    AppStore.dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.fractionCountDelete(this.props.params.code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <ReplaceModal
                            elements={ props.fractions }
                            title={ `${i18n.fraction} [${fraction.code}]` }
                            label={ i18n.fraction }
                            onReplace={ this.onReplace }
                        />,
                        dismissible: false,
                    }
                    AppStore.dispatch(SieauAction.setPopup(popup))
                },
                links: this.getFractionLinks(props),
            }
        })()
        if (getUser().consultant === '1') {
            this.setActions(omit(actions, ['save', 'edit', 'deleteCheck', 'replace']))
        } else {
            this.setActions(actions)
        }
        updateMaterialize()
    }

    componentDidUpdate() {
        this.toNavbarFraction()
    }

    componentDidMount() {
        this.toNavbarFraction()
    }

    render() {
        const { readMode, fraction } = this.state
        const { params, referencialStatus, referencialSupport } = this.props

        const disabled = {
            active: !readMode,
            disabled: readMode,
        }

        const nature = [
            { id: '0', name: i18n.unknownNature },
            { id: '1', name: i18n.liquidFraction },
            { id: '2', name: i18n.solidFraction },
            { id: '3', name: i18n.gaseousFraction },
        ]

        const activeIcon = fraction.state === '3' ? <i className='material-icons'>lock</i> : null

        return (
            <Box margin='10px 10px 10px 0'>
                <Card>
                    <CardTitle title={i18n.description}/>
                    <CardContent>
                        <Grid2 container spacing={1}>
                            <Grid2 size={3}>
                                <Input
                                    title={ i18n.code }
                                    value={ fraction.code }
                                    onChange={ code => this.setState({ fraction: { ...fraction, code } }) }
                                    maxLength={ 5 }
                                    disabled={params.code !== 'new'}
                                />

                            </Grid2>
                            <Grid2 size={3} marginTop={2}>
                                <Checkbox
                                    label={ i18n.active }
                                    checked={ fraction.actif === '1' }
                                    onChange={ (e) => this.setState({ fraction: { ...fraction, actif: e ? '1' : '0' } }) }
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 offset={6} />
                            <Grid2 size={6}>
                                <Input
                                    id='fraction_name'
                                    title={ i18n.name }
                                    value={ fraction.name }
                                    onChange={ name => this.setState({ fraction: { ...fraction, name } }) }
                                    maxLength={ 255 }
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <Input
                                    title={ i18n.internationalName }
                                    value={ fraction.internationalName }
                                    maxLength={ 255 }
                                    onChange={ internationalName => this.setState({ fraction: { ...fraction, internationalName } }) }
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Textarea
                                    title={ i18n.comment }
                                    value={ fraction.comment }
                                    onChange={ comment => this.setState({ fraction: { ...fraction, comment } }) }
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 container size={3}>
                                <Grid2 size={fraction.state === '3' ? 11 : 12}>
                                    <Select
                                        options={ referencialStatus }
                                        label={ i18n.status }
                                        onChange={ state => this.setState({ fraction: { ...fraction, state: hasValue(state) ? state.toString() : '' } }) }
                                        value={ parseInt(fraction.state) }
                                        nullLabel='&nbsp;'
                                        { ...disabled }
                                    />
                                </Grid2>
                                { fraction.state === '3' && (
                                    <Grid2 size={1} paddingTop={2}>
                                        { activeIcon }
                                    </Grid2>
                                )}
                            </Grid2>
                            <Grid2 size={9}>
                                <Input
                                    title={ i18n.author }
                                    value={ fraction.author }
                                    onChange={ author => this.setState({ fraction: { ...fraction, author } }) }
                                    maxLength={ 50 }
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <SimpleDatePicker
                                    id='creationDate'
                                    label={i18n.creationDate}
                                    value={fraction.creationDate}
                                    max={fraction.updateDate}
                                    onChange={creationDate => this.setState({ fraction: { ...fraction, creationDate } })}
                                    { ...disabled }
                                />

                            </Grid2>
                            <Grid2 size={6}>
                                <SimpleDatePicker
                                    id='updateDate'
                                    label={i18n.modification}
                                    value={fraction.updateDate}
                                    onChange={updateDate => this.setState({ fraction: { ...fraction, updateDate } })}
                                    min={fraction.creationDate}
                                    { ...disabled }
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                <Select
                                    options={ getReferencialComponent(nature) }
                                    label={ i18n.nature }
                                    nullLabel='&nbsp;'
                                    onChange={ v => this.setState({ fraction: { ...fraction, nature: v } }) }
                                    value={ fraction.nature }
                                    { ...disabled }
                                />

                            </Grid2>
                            <Grid2 size={6}>
                                <Select
                                    options={ getReferencialComponent(referencialSupport) }
                                    label={ i18n.support }
                                    nullLabel='&nbsp;'
                                    onChange={ supportCode => this.setState({ fraction: { ...fraction, supportCode } }) }
                                    value={ fraction.supportCode }
                                    { ...disabled }
                                />
                            </Grid2>
                        </Grid2>
                    </CardContent>
                </Card>
            </Box>
        )
    }
}

FractionApp.propTypes = {
    params: PropTypes.shape({
        code: PropTypes.string,
    }),
    fraction: PropTypes.instanceOf(FractionDto),
    referencialStatus: PropTypes.instanceOf(DtoReferencial),
    referencialSupport: PropTypes.instanceOf(DtoReferencialItem),
    getLink: PropTypes.func,
    isEnableEdit: PropTypes.bool,
    changeEditMode: PropTypes.func,
    isEditMode: PropTypes.bool,
}

const mapStateToProps = store => {
    return {
        fraction: store.FractionReducer.fraction,
        fractions: store.FractionReducer.fractions,
        referencialStatus: store.ReferencialReducer.referencialStatus,
        referencialSupport: store.ReferencialReducer.referencialSupport,
    }
}

export default connect(mapStateToProps)(FractionApp)
